import React from "react";
import CommonBanner from "../component/Common/CommonBanner";
import { useTranslation } from "react-i18next";
import FlightBookingsModificationArea from "component/flightBookingsModification";
const FlightBookingModification = () => {
    const { t } = useTranslation();
    return (
        <>
            <CommonBanner
                heading={t("flightBookingModification")}
                pagination="Booking modification"
            />
            <FlightBookingsModificationArea/>
        </>
    );
};

export default FlightBookingModification;
